import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { useCustomerDefaultQuery } from "@portal/queries/user-query";
import { sessionStore } from "@portal/util/browser-storage";
import { Spin } from "antd";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

function InitialPage() {
  const { customer_id } = useParams<AppPageParams>();
  const navigate = usePageNavigate();
  const location = useLocation();
  useCustomerDefaultQuery(handleNavigate);
  function handleSessionStorage() {
    if (customer_id) {
      sessionStore.setItem("customer_id", customer_id);
    }
  }

  function handleNavigate() {
    const param = new URLSearchParams(location.search);

    if (customer_id) {
      param.append("customer_id", customer_id);
    }
    navigate({
      appPage: "LOGIN",
      searchParams: param.has("entity_type") ? param : undefined,
    });
  }

  useEffect(handleSessionStorage, [customer_id]);
  return (
    <>
      <Spin tip="Loading..." spinning size="large" fullscreen />
    </>
  );
}

export { InitialPage };
